<header>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-10">
      </div>
      <div class="col-md-2">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700; ">
          <a [routerLink]="['/home-espanol']" style="text-decoration: none; color: inherit; ">
            <div class="container" style="border: 1px solid #257dff; border-radius: 25px; ">
              &nbsp;&nbsp;Español
            </div>
          </a>
        </span>
      </div>
    </div>
  </div>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-12">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700">
          GoogleAssistantPrivacyLitigation.com
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(877) 411-4704
        </span>
      </div>
    </div>
  </div>
  <br />
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #257dff ">
    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/faq']" style="color: white; font-weight: bold">FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold ">Notice</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File Your Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/claim-form']" style="color:white; font-weight: bold ">Claim Form</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/exclusion-request']" style="color:white; font-weight: bold ">File an Exclusion</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/contact']" style="color:white; font-weight: bold ">Contact Us</a>
          </li>
        </ul>
      </div>
    </div>

  </nav>

  
</header>
<div class="container" style="border:1px solid #bebaba">
  <div class="text-center" style="font-weight:bold">

    <br />

    This official website is maintained by the Claims Administrator
    <br />
    <br />
  </div>
  <br />
  <div class="row indentContent">
    <div class="col-md-12">
      <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align: center; font-weight: bold">
        <h3>Frequently Asked Questions - FAQs</h3>
      </div>
      <br />
      <p style="text-align:center;font-weight:bold">BASIC INFORMATION</p>
      <div id="accordion">
        <div class="card">
          <div class="card-header">
            <a class="card-link" data-toggle="collapse" href="#collapseOne">
              1.	Why did I get this Notice?
            </a>
          </div>
          <div id="collapseOne" class="collapse" data-parent="#accordion">
            <div class="card-body">
              The Court authorized this Notice because you have a right to know about a proposed Settlement, and your rights and options, before the Court decides
              whether to approve the Settlement. This Notice explains the lawsuit, the Settlement, and your legal rights. It also describes the available benefits,
              who is eligible to receive them, and how to get them. Your legal rights are affected whether you act or not.<br /><br />

              Judge Beth Labson Freeman, of the United States District Court for the Northern District of California, is in charge of this case and will decide
              whether to approve the Settlement. This lawsuit is known as <i>In re Google Assistant Privacy Litigation</i>, No. 4:19-cv-04286. The people who sued are
              called the “Plaintiffs.” Google is the “Defendant.”<br /><br />

              If you have questions, you can visit the website <a href="www.GoogleAssistantPrivacyLitigation.com" target="_blank">www.GoogleAssistantPrivacyLitigation.com</a>,
              call toll-free 1-877-411-4704, or write to the Claims Administrator at the address below for more information.<br /><br />

              <p style="text-align:center">
                Google Assistant Privacy Settlement<br />
                c/o A.B. Data, Ltd.<br />
                P.O. Box 170500<br />
                Milwaukee, WI 53217<br />
                <a href="mailto:info@GoogleAssistantPrivacyLitigation.com">info@GoogleAssistantPrivacyLitigation.com</a><br /><br />
              </p>
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwo">
              2.	What is this lawsuit about?
            </a>
          </div>
          <div id="collapseTwo" class="collapse" data-parent="#accordion">
            <div class="card-body">
              The lawsuit alleges that Google Assistant can activate and record communications even when a user does not intentionally trigger Google Assistant
              with a Hot Word, like “Okay Google,” or manually activate Google Assistant on their device. Plaintiffs refer to such instances as “False Accepts”
              and allege that Google wrongfully collects, uses, and discloses user audio recordings from False Accepts, including to improve the speech recognition
              abilities of Google Assistant. Plaintiffs claim Google’s conduct violates individuals’ privacy rights, constitutes a breach of the privacy assurances
              that Google makes to users in its Privacy Policy, and is an unlawful practice. Google denies all of Plaintiffs’ allegations. The Court has not made
              any determination as to who is right or whether Google did anything wrong.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThree">
              3.	What are Google-Made Devices and Google Assistant Enabled Devices?
            </a>
          </div>
          <div id="collapseThree" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Google-Made Devices are devices manufactured and sold by Google either directly or through third-party retailers that come with Google Assistant
              pre-installed or on which Google Assistant can be downloaded, including Google’s smart home speakers (Google Home, Home Mini, and Home Max); smart
              displays (Google Nest Hub and Google Nest Hub Max); and Pixel smartphones.<br /><br />

              Google Assistant Enabled Devices include both Google-Made Devices and non-Google made devices that come with Google Assistant pre-installed or on
              which Google Assistant can be downloaded, such as smartphones, smart speakers, smart displays, or smart TVs with a microphone. Household devices,
              such as thermostats, vacuums, humidifiers, and other electronic tools and devices that are not equipped with a microphone or that do not have Google
              Assistant pre-installed and do not have the capability of having a Google Assistant application downloaded onto them are not considered Google
              Assistant Enabled Devices.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseFour">
              4.	What is a class action?
            </a>
          </div>
          <div id="collapseFour" class="collapse" data-parent="#accordion">
            <div class="card-body">
              In a class action, one or more people called “class representatives” sue on behalf of themselves and other people who have similar claims.
              These people together are a “class” or “class members.” One court decides the issues for all class members, except for those people who
              exclude themselves from the class.<br /><br />

              In this case, Asif Kumandan is the class representative for the Purchaser Settlement Class and Asif Kumandan, Melissa Spurr, Lourdes Galvan,
              and Eleeanna Galvan are the class representatives for the Privacy Settlement Class. (<i>See</i> Question 6.)
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseFive">
              5.	Why is there a Settlement?
            </a>
          </div>
          <div id="collapseFive" class="collapse" data-parent="#accordion">
            <div class="card-body">
              The Court did not decide in favor of the Plaintiffs or Google. Instead, both sides agreed to a Settlement. That way, both sides avoid the
              costs and risks of a trial, and the Settlement Class Members will receive the benefits described in this Notice, whereas they might
              otherwise get nothing.  The proposed Settlement does not mean that any law was broken or that Google did anything wrong. The class
              representatives and their attorneys think the Settlement is best for all Settlement Class Members.
            </div>
          </div>
        </div>
        <br />
        <p style="text-align:center;font-weight:bold">WHO IS IN THE SETTLEMENT?</p>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSix">
              6.	Who is in the Settlement?
            </a>
          </div>
          <div id="collapseSix" class="collapse" data-parent="#accordion">
            <div class="card-body">
              You are included in this Settlement and are a Settlement Class Member if you are a member of one or both of the following Settlement Classes:<br /><br />

              <ul>
                <li>
                  You are a member of the Purchaser Settlement Class if you are a User who purchased a Google-Made Device in the United States or its territories between May 18, 2016 and March 19, 2026.
                </li>
                <li>
                  You are a member of the Privacy Settlement Class if you are a User of Google Assistant or were a member of a User’s Household between May 18, 2016 and March 19, 2026, and your communications were recorded or otherwise obtained by Google Assistant as a result of a False Accept or disclosed to any third-party review vendor.
                </li>
                <li>
                  “Users” are individuals who reside in the United States or its territories whose Google accounts were associated with at least one Google Assistant Enabled Device during the Class Period;
                </li>
                <li>
                  “Household” is a group of individuals sharing a common abode;
                </li>
                <li>
                  “Google Assistant Enabled Devices” are devices that come with Google Assistant pre-installed or on which Google Assistant can be downloaded;
                </li>
                <li>
                  Google-Made Devices” are Google Assistant Enabled Devices manufactured and sold by Google either directly or through third-party retailers, including Google’s own smart home speakers (Google Home, Home Mini, and Home Max); smart displays (Google Nest Hub and Nest Hub Max); and its Pixel smartphones;
                </li>
                <li>
                  “False Accept” is an instance where a Google Assistant Enabled Device records and transmits audio data to Google’s servers because a Hot Word was detected although a Hot Word was not spoken; and
                </li>
                <li>
                  “Hot Word” is a word or phrase (such as “OK Google” or “Hey Google”) which can be used to activate Google Assistant on certain Google Assistant Enabled Devices.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSeven">
              7.	Who is <u>not</u> included?
            </a>
          </div>
          <div id="collapseSeven" class="collapse" data-parent="#accordion">
            <div class="card-body">
              You are not included in this Settlement if you are:<br /><br />

              <ul>
                <li>
                  Any judge or magistrate presiding over this lawsuit, or any members of their families or staff;
                </li>
                <li>
                  Google, Google’s subsidiaries, successors, predecessors, and any entity in which Google or its parent has a controlling interest,
                  and their current or former employees, officers, and directors;
                </li>
                <li>
                  A person who properly executes and files a timely Request for Exclusion from the Settlement Classes (see Question 21);
                </li>
                <li>
                  A person whose claims in this matter have been finally adjudicated on the merits or otherwise released;
                </li>
                <li>
                  Any individual who previously opted out of the certified Purchaser Class, as identified at ECF No. 440-4, unless you
                  choose to rejoin the Settlement Classes (see Question 26);
                </li>
                <li>
                  Any individual who, no later than <b>August 27, 2026</b>, both (A) file or serve a written arbitration demand, or provide written
                  notice to Google of their intent to pursue arbitration against Google relating to the Released Claims, and (B) execute an individual
                  release of their claims;
                </li>
                <li>
                  Any legal representatives, successors, and assigns of any excluded persons; and
                </li>
                <li>
                  Plaintiffs’ Counsel and Defendants’ Counsel.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseEight">
              8.	What should I do if I am still not sure whether I am included?
            </a>
          </div>
          <div id="collapseEight" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If you are still not sure whether you are included in the Settlement or have any other questions, you can call toll-free 1-877-411-4704 or write
              to the Claims Administrator at the address below for more information.<br /><br />

              <p style="text-align:center">
                Google Assistant Privacy Settlement<br />
                c/o A.B. Data, Ltd.<br />
                P.O. Box 170500<br />
                Milwaukee, WI 53217<br />
                Email: info@GoogleAssistantPrivacyLitigation.com<br /><br />
              </p>
            </div>
          </div>
        </div>
        <br />
        <p style="text-align:center;font-weight:bold">THE SETTLEMENT BENEFITS</p>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseNine">
              9.	What does the Settlement provide?
            </a>
          </div>
          <div id="collapseNine" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If the Settlement is approved and becomes final, money will be provided to eligible Settlement Class Members. Google will pay $68 million into
              a Settlement Fund.  The Settlement Fund will be used to pay:<br /><br />

              <ul>
                <li>
                  Notice and administration costs;
                </li>
                <li>
                  Escrow fees;
                </li>
                <li>
                  Taxes (and tax expenses);
                </li>
                <li>
                  Attorneys’ fees and expenses authorized by the Court;
                </li>
                <li>
                  Service awards for each named Plaintiff authorized by the Court; and
                </li>
                <li>
                  Timely and valid Claims made by eligible Settlement Class Members.
                </li>
              </ul>

              The Settlement Agreement, available at <a href="www.GoogleAssistantPrivacyLitigation.com" target="_blank">www.GoogleAssistantPrivacyLitigation.com</a>, has more information.

            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTen">
              10.	How much will my payment be?
            </a>
          </div>
          <div id="collapseTen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              At this time, it is unknown how much each Settlement Class Member who files a timely and valid claim will receive.<br /><br />

              The Net Settlement Fund (that is, the Settlement fund minus notice and administration costs, escrow fees, taxes and taxes expenses,
              and any Court-approved attorneys’ fees and expenses and service awards to the named Plaintiffs) will be used to pay eligible
              Settlement Class Members based on a Plan of Allocation. The Plan of Allocation has been filed with the Court and is available
              for review at <a href="www.GoogleAssistantPrivacyLitigation.com" target="_blank">www.GoogleAssistantPrivacyLitigation.com</a>.<br /><br />

              The Net Settlement Fund will be divided proportionally among members of the Purchaser Settlement Class and Privacy Settlement
              Class who file timely and valid Claim Forms based on the number of points allocated per timely and valid Claim Form. Claimants
              who are members of the Purchaser Settlement Class will be assigned four (4) points for every eligible Google-Made Device included
              in their Claim, up to a cap of three (3) Google-Made Devices. Claimants who are members of the Privacy Settlement Class will be
              assigned one (1) point.<br /><br />

              Money will be paid proportionally based on the total number of points for each Claimant.<br /><br />

              Each Settlement Class Member must submit an individual Claim, except that parents or legal guardians must submit a Claim Form
              for a member of the Settlement Classes who is under the age of 18 as of <b>August 27, 2026</b>.<br /><br />

              The final payment amounts will not be known until the Claims Administrator determines the total number of eligible Claimants and
              the total number of points reflected by their Claim Forms.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseEleven">
              11.	What happens if there are funds remaining after distribution?
            </a>
          </div>
          <div id="collapseEleven" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If there are any funds remaining after all Settlement distributions are made, to the extent feasible, the Claims Administrator will
              send a second distribution to Authorized Claimants who cashed their initial distribution from the Net Settlement Fund. If it is not
              feasible to distribute the remaining funds among such Authorized Claimants, the remaining funds will be distributed to a non-profit
              organization approved by the Court. No remaining funds will be returned to Google.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwelve">
              12.	What am I giving up if I stay in the Settlement?
            </a>
          </div>
          <div id="collapseTwelve" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Unless you exclude yourself (or excluded yourself from the previously certified purchaser class and do not elect to rejoin the Settlement Classes)
              (see Questions 21-26), you cannot sue, continue to sue, or be part of any other legal proceeding against Google about the claims in this lawsuit.
              All of the Court’s decisions will bind you. The “Releases” section in the Settlement Agreement describes the legal claims that you give up if you
              remain in the Settlement.<br /><br />

              The Settlement Agreement can be viewed at <a href="www.GoogleAssistantPrivacyLitigation.com" target="_blank">www.GoogleAssistantPrivacyLitigation.com</a>.<br /><br />

              If you have any questions, you can talk to the lawyers listed in Question 18 for free, or you can talk to your own lawyer if you have questions
              about what this means.
            </div>
          </div>
        </div>
        <br />
        <p style="text-align:center;font-weight:bold">HOW TO GET A PAYMENT </p>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirteen">
              13.	How can I get a payment?
            </a>
          </div>
          <div id="collapseThirteen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              To ask for a payment, you must complete and submit a valid Claim Form by <b>August 27, 2026</b>. You can get a Claim Form at
              <a href="www.GoogleAssistantPrivacyLitigation.com" target="_blank">www.GoogleAssistantPrivacyLitigation.com</a> or by calling 1-877-411-4704.<br /><br />

              If you received an email about this Settlement that included a Unique ID and PIN number, you should use these codes when you submit your Claim Form.
              If you did not receive an email and do not have a Unique ID and PIN number, you can still submit a Claim Form if you are a Settlement Class Member.<br /><br />

              You must submit your Claim Form online at <a href="www.GoogleAssistantPrivacyLitigation.com" target="_blank">www.GoogleAssistantPrivacyLitigation.com</a> or by mail postmarked no later than <b>August 27, 2026</b>.  Claims submitted by mail should be sent to:<br /><br />

              <p>
                Google Assistant Privacy Settlement<br />
                c/o A.B. Data, Ltd.<br />
                P.O. Box 170500<br />
                Milwaukee, WI 53217<br /><br />
              </p>

              Each Claim Form must be personally signed under penalty of perjury and must be supported by the information or documents specified in the instructions
              contained in the Claim Form or otherwise given by the Claims Administrator. The bulk submission of Claim Forms by any claims aggregator or person or
              entity who claims to be an assignee of rights associated with any of the claims that were or could have been alleged in the Action will not be permitted.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseFourteen">
              14.	How do Settlement Class Members who are minors (under the age of 18) file a claim?
            </a>
          </div>
          <div id="collapseFourteen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If a Settlement Class Member is a minor, their Claim must be submitted and signed by their parent or legal guardian. A minor is defined as a person who is under the age of 18 as of <b>August 27, 2026</b>.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseFifthteen">
              15.	When will I get my payment?
            </a>
          </div>
          <div id="collapseFifthteen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Authorized Claimants will receive their payments if the Court grants final approval to the Settlement and after any appeals are resolved. If there are appeals, resolving them can take time. Please be patient.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixTeen">
              16.	How can I verify or update my contact information?
            </a>
          </div>
          <div id="collapseSixTeen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If you change your mailing address or email address after you submit a Claim Form, it is your responsibility to give your updated contact information to the Claims Administrator.
              You can tell the Claims Administrator about changes to your contact information by calling 1-877-411-4704, emailing info@GoogleAssistantPrivacyLitigation.com, or writing to:<br /><br />

              <p style="text-align:center">
                Google Assistant Privacy Settlement
                c/o A.B. Data, Ltd.
                P.O. Box 170500
                Milwaukee, WI 53217
              </p>

            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseSevenTeen">
              17.	Can I file a claim if I excluded myself previously?
            </a>
          </div>
          <div id="collapseSevenTeen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              It depends. If you excluded yourself from the previously certified purchaser class but now wish to file a claim as part of this Settlement, you must rejoin the
              Settlement Classes. If you do not rejoin the Settlement Classes, you are not included and cannot file a claim in this Settlement.<br /><br />

              To rejoin the Settlement Classes, please submit a Claim Form as directed in FAQ 13.  Submission of a Claim Form will withdraw your prior request for exclusion
              and cause you to rejoin the Settlement Classes.
            </div>
          </div>
        </div>
        <br />
        <p style="text-align:center;font-weight:bold">THE LAWYERS REPRESENTING YOU</p>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseEightTeen">
              18.	Do I have a lawyer in the case?
            </a>
          </div>
          <div id="collapseEightTeen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Yes. The Court has appointed lawyers to represent you and the other Settlement Class Members. These lawyers are called Class Counsel.
              The following lawyers are lead counsel in representing the Settlement Classes:<br /><br />

              <div class="table-responsive">
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <td style="vertical-align:middle; width:50%">
                        Erin Green Comite<br />
                        Scott+Scott Attorneys at Law LLP 156 South Main Street<br />
                        P.O. Box 192<br />
                        Colchester, CT 06415
                      </td>
                      <td style="vertical-align:middle; width:50%">
                        Christian Levis<br />
                        Lowey Dannenberg<br />
                        44 South Broadway, Suite 1100<br />
                        White Plains, NY 10601
                      </td>
                    </tr>
                </table>
              </div>
              <br />
              You will not be charged for contacting these lawyers. If you want to be represented by your own lawyer, you may hire one at your own expense.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseNineTeen">
              19.	Should I get my own lawyer?
            </a>
          </div>
          <div id="collapseNineTeen" class="collapse" data-parent="#accordion">
            <div class="card-body">
              You do not need to hire your own lawyer because Class Counsel is working on your behalf. You may, however, hire your own lawyer to represent
              you if you wish. For example, you can ask your own lawyer to appear in Court if you want someone other than Class Counsel to speak for you.
              You may also appear for yourself without a lawyer. If you hire your own lawyer, you will have to pay for that lawyer on your own.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwenty">
              20.	How will the lawyers be paid?
            </a>
          </div>
          <div id="collapseTwenty" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Plaintiffs’ Counsel will ask the Court for an award of attorneys’ fees of up to one-third of the Settlement Fund, expenses of up to $1,600,000,
              and up to $10,000 in service awards for each class representative for their work on behalf of the Settlement Classes.  The Court will determine
              these amounts. Any attorneys’ fees, expenses, notice and administration costs, and service awards approved by the Court will be paid out of the
              Settlement Fund.<br /><br />

              A copy of Plaintiffs’ Counsel’s Motion for Attorneys’ Fees and Expenses and for Plaintiffs’ Service Awards will be available at
              <a href="www.GoogleAssistantPrivacyLitigation.com" target="_blank">www.GoogleAssistantPrivacyLitigation.com</a> within three business days after
              filing the motion with the Court on <b>July 23, 2026</b>.
            </div>
          </div>
        </div>
        <br />
        <p style="text-align:center;font-weight:bold">EXCLUDING YOURSELF FROM THE SETTLEMENT</p>
        <p>
          If you do not want a payment from the Settlement and you want to keep your right, if any, to sue Google on your own about the claims in this lawsuit,
          then you must take steps to get out of the Settlement. This is called excluding yourself from – or “opting out” of – the Settlement.
        </p>
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyOne">
              21.	How do I get out of the Settlement?
            </a>
          </div>
          <div id="collapseTwentyOne" class="collapse" data-parent="#accordion">
            <div class="card-body">
              To exclude yourself from the Settlement, you must send a request in writing by First-Class U.S. Mail, or electronically via the exclusion
              request portal on the Settlement Website.
              Your Request for Exclusion must include:<br /><br />

              <ul>
                <li>
                  Your full name, address, telephone number, and email address;
                </li>
                <li>
                  The case name and number: In re Google Assistant Privacy Litigation, No. 4:19-cv-04286;
                </li>
                <li>
                  Information or proof that shows that you are member of one or both of the Settlement Classes (e.g., the unique ID from your email notice or the
                  email address associated with your or your Household member’s Google Assistant Enabled Devices);
                </li>
                <li>
                  A statement that you would like to “opt out” or be excluded from the Settlement Classes; and
                </li>
                <li>
                  Your handwritten signature in ink or signature submitted through the exclusion request portal on the Settlement Website and the date of your signature.
                  Electronic signatures (including DocuSign signatures) will not be considered a personal signature and will be deemed invalid, except those submitted
                  through the exclusion request portal on the Settlement Website. You must personally sign and date your Request for Exclusion; your lawyer (if applicable)
                  may not sign on your behalf. However, a parent or legal guardian is allowed to sign on behalf of a minor who is opting out.
                </li>
              </ul>

              Your Request for Exclusion must either be submitted electronically via the exclusion request portal on the Settlement Website no later than <b>August 27, 2026</b>,
              or be postmarked no later than <b>August 27, 2026</b>, and sent via First-Class U.S. Mail to:<br /><br />

              <p style="text-align:center">
                Google Assistant Privacy Settlement<br />
                EXCLUSIONS<br />
                c/o A.B. Data, Ltd.<br />
                P.O. Box 173001<br />
                Milwaukee, WI 53217<br />
              </p>

              Each Request for Exclusion must be submitted individually. Requests for Exclusion on behalf of groups, including “mass” or “class” opt outs, will not be
              permitted. Any Settlement Class Member who does not submit a timely and valid written request for exclusion will be bound by all Court proceedings, orders,
              and judgments, whether or not he, she, or it timely submits a Claim Form.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyTwo">
              22.	If I exclude myself from the Settlement, can I still get a payment?
            </a>
          </div>
          <div id="collapseTwentyTwo" class="collapse" data-parent="#accordion">
            <div class="card-body">
              No. You will not get a payment if you exclude yourself.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyThree">
              23.	If I don’t exclude myself, can I sue Google for the same thing later?
            </a>
          </div>
          <div id="collapseTwentyThree" class="collapse" data-parent="#accordion">
            <div class="card-body">
              No. Unless you exclude yourself, you give up the right to sue Google for the claims this Settlement resolves. You must exclude yourself from the Settlement
              if you want to try to pursue your own lawsuit.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyFour">
              24.	What happens if I opt out?
            </a>
          </div>
          <div id="collapseTwentyFour" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If you opt out of the Settlement or previously excluded yourself from the certified Purchaser Class and do not rejoin the Settlement Classes, you will not
              have any rights as a Settlement Class Member under this Settlement. You will not get a payment from the Settlement and will not be bound by any further
              orders or judgments in this case. Also, you will keep the right, if any, to sue Google on your own for claims in this lawsuit at your own expense.<br /><br />

              If a Settlement Class Member who did not previously exclude themselves from the certified Purchaser Class submits both a Claim Form and a timely Request
              for Exclusion, the Settlement Class Member will be excluded from the Settlement and their Claim Form will be void and invalid, unless they ask to cancel
              their exclusion request.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyFive">
              25.	If I excluded myself earlier, do I need to exclude myself again?
            </a>
          </div>
          <div id="collapseTwentyFive" class="collapse" data-parent="#accordion">
            <div class="card-body">
              No. If you submitted a timely request to exclude yourself from the certified Purchaser Class in 2024, you will continue to be excluded from this Settlement
              unless you rejoin one or both of the Settlement Classes by submitting a valid and timely Claim Form.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentySix">
              26.	How do I cancel my previous opt-out request?
            </a>
          </div>
          <div id="collapseTwentySix" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If you excluded yourself from the certified Purchaser Class in 2024 but want to rejoin one or both of the Settlement Classes now, you can cancel your previous
              opt-out (or exclusion) request. To do so, you may submit a valid and timely Claim Form by <b>August 27, 2026</b>, in accordance with the instructions in FAQ 13.
            </div>
          </div>
        </div>
        <br />
        <p style="text-align:center;font-weight:bold">OBJECTING TO THE SETTLEMENT</p>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentySeven">
              27.	How do I tell the Court if I do not like the Settlement?
            </a>
          </div>
          <div id="collapseTwentySeven" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If you are a Settlement Class Member, you have a right to object to or comment on any part of the proposed Settlement, Plan of Allocation, and/or the request
              for attorneys’ fees and expenses and service awards. The Court will consider your views. You cannot ask the Court to order a different Settlement; the Court
              can only approve or reject the Settlement. If the Court does not approve the Settlement, no Settlement payments will be made, and the lawsuit will continue.
              If that is what you want to happen, you must object.<br /><br />

              To object, you must send a letter to the Court saying that you object to the proposed Settlement in <i>In re Google Assistant Privacy Litigation</i>, No. 4:19-cv-04286.<br /><br />

              Your objection letter must include:<br />
              <ul>
                <li>
                  Your full name, address, telephone number, and email address;
                </li>
                <li>
                  If you have a lawyer, your lawyer’s full name, address, telephone number, and email address;
                </li>
                <li>
                  The case name and number: <i>In re Google Assistant Privacy Litigation</i>, No. 4:19-cv-04286;
                </li>
                <li>
                  Information or proof that shows that you are included in one or both of the Settlement Classes (e.g., the unique ID from your email notice or the email address
                  associated with your or your Household member’s Google Assistant Enabled Device);
                </li>
                <li>
                  The reasons you object to the proposed Settlement, Plan of Allocation, and/or the request for attorneys’ fees and expenses and service awards;
                </li>
                <li>
                  Any documents or evidence that you think supports your objection;
                </li>
                <li>
                  A statement saying if your objection applies only to you, part of the Settlement Classes, or all Settlement Classes;
                </li>
                <li>
                  A list of all cases in which you or your lawyer filed an objection within the past five years;
                </li>
                <li>
                  A statement of whether you and/or your lawyer intend to speak at the Final Approval Hearing;
                </li>
                <li>
                  The identity of any witnesses you may call to testify at the Final Approval Hearing and all exhibits you intend to introduce at the Final Approval Hearing; and
                </li>
                <li>
                  Your signature in ink and the date of your signature (electronic signatures, including but not limited to DocuSign, will not be considered personal signature and
                  will be deemed invalid). You must personally sign and date your objection; your lawyer (if applicable) may not solely sign on your behalf. However, a parent or
                  legal guardian is allowed to sign on behalf of a minor who is objecting.
                </li>
              </ul>

              If you are approved to file electronically through the Court’s CM/ECF system, you can file the objection electronically at <a href="https://ecf.cand.uscourts.gov/">https://ecf.cand.uscourts.gov/</a> . Otherwise,
              you can file the objection in person at any location of the United States District Court for the Northern District of California, or mail the objection by First-Class
              U.S. Mail, so that it is submitted electronically or postmarked no later than <b>August 27, 2026</b>, to the following address:<br /><br />

              <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
                Court
              </div>
              <br />
              <p style="text-align:center">
                Clerk of Court<br />
                United States District Court<br />
                Northern District of California<br />
                280 South 1st Street<br />
                San Jose, CA 95113
              </p>

            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyEight">
              28.	If I object to the Settlement, can I still file a claim?
            </a>
          </div>
          <div id="collapseTwentyEight" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Yes. If you are a Settlement Class Member, you may file a claim even if you object to, or comment on, the Settlement.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwentyNine">
              29.	What is the difference between objecting and asking to be excluded?
            </a>
          </div>
          <div id="collapseTwentyNine" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Objecting is simply telling the Court that you do not like something about the Settlement. You can only object if you stay
              in the Settlement Classes. If you object to the Settlement, you can still submit a Claim Form as a Settlement Class Member.<br /><br />

              Excluding yourself is telling the Court that you do not want to be a part of the Settlement. If you exclude yourself, you cannot
              receive a payment from the Settlement. If you exclude yourself, you cannot object to the Settlement, because it no longer affects you.
            </div>
          </div>
        </div>
        <br />
        <p style="text-align:center;font-weight:bold">THE COURT’S FINAL APPROVAL HEARING</p>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirty">
              30.	When and where will the Court decide whether to approve the Settlement?
            </a>
          </div>
          <div id="collapseThirty" class="collapse" data-parent="#accordion">
            <div class="card-body">
              The Court will hold a Final Approval Hearing on <b>October 1, 2026, at 9:00 a.m. PT</b> at the United States District Court for the Northern
              District of California, San Jose Courthouse, 280 South 1st Street, Courtroom 1 – 5th Floor, San Jose, CA 95113.<br /><br />

              At this hearing, the Court will consider whether the Settlement is fair, reasonable, and adequate. If there are objections, the Court
              will consider them and listen to Settlement Class Members who have asked to speak at the hearing.<br /><br />

              The Court may also decide whether and how much to award in attorneys’ fees and expenses and service awards to the class representatives.
              After the hearing, the Court will decide whether to approve the Settlement. We do not know how long these decisions will take.<br /><br />

              The Court may reschedule the Final Approval Hearing or change any of the deadlines described in this Notice. The Final Approval Hearing
              may be moved to a different date or time and may change without additional notice.<br /><br />

              Be sure to return to the website for possible updates before the date of the Final Hearing..  You can also access the case docket via
              the Court’s Public Access to Court Electronic Records (PACER) system at <a href="https://ecf.cand.uscourts.gov">https://ecf.cand.uscourts.gov</a>.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirtyOne">
              31.	Do I have to come to the Final Approval Hearing?
            </a>
          </div>
          <div id="collapseThirtyOne" class="collapse" data-parent="#accordion">
            <div class="card-body">
              No. Class Counsel will answer any questions the Court may have. You may attend at your own expense if you wish. If you send an objection, you do not
              have to come to the Final Approval Hearing to talk about it. As long as you mailed your written objection on time, the Court will consider it. You
              may also pay your own lawyer to attend, but it is not necessary.
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirtyTwo">
              32.	May I speak at the Final Approval Hearing?
            </a>
          </div>
          <div id="collapseThirtyTwo" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Yes. You may ask the Court for permission to speak at the Final Approval Hearing, either in person or through your own lawyer. If you appear through
              your own lawyer, you are responsible for hiring and paying that lawyer.<br /><br />

              To do so, you (or your lawyer) must submit to the Court a notice that you intend to appear at the Final Approval Hearing in <i>
                In re Google Assistant
                Privacy Litigation
              </i>, No. 4:19-cv-04286. If you (or your lawyer) intends to object to the Settlement at the Final Approval Hearing, you must follow
              the instructions in FAQ 27. If not, your notice of intent to appear should still include your full name, address, telephone number, email address,
              and signature, and if you have a lawyer, your lawyer’s full name, address, telephone number, and email address. Your notice of intention to appear
              must be postmarked no later than <b>August 27, 2026</b>, and sent to the Court’s address listed in FAQ 27 or submitted through the Court’s CM/ECF (if you
              are approved to do so) by 11:59 p.m. Pacific Time on <b>August 27, 2026</b>.
            </div>
          </div>
        </div>
        <br />
        <p style="text-align:center;font-weight:bold">IF YOU DO NOTHING</p>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirtyThree">
              33.	What happens if I do nothing at all?
            </a>
          </div>
          <div id="collapseThirtyThree" class="collapse" data-parent="#accordion">
            <div class="card-body">
              If you are a Settlement Class Member and you do nothing, you will not get any money from the Settlement. You will be bound by the Court’s decisions
              and the Settlement. You will give up your right to start a lawsuit, continue with a lawsuit, or be part of any other lawsuit against Google for
              claims in this lawsuit. To receive a payment, you must complete and submit a Claim Form by August 27, 2026 (see FAQ 13).<br /><br />

              If you timely submitted a request for exclusion from the certified Purchaser Class in 2024, you will continue to be excluded from this Settlement
              unless you rejoin one or both of the Settlement Classes, which you may do by submitting a valid and timely Claim Form by August 27, 2026.
            </div>
          </div>
        </div>
        <br />
        <p style="text-align:center;font-weight:bold">GETTING MORE INFORMATION</p>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirtyFour">
              34.	Are more details about the Settlement available?
            </a>
          </div>
          <div id="collapseThirtyFour" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Yes. You can locate more details in the Settlement Agreement and other case documents, located on the Court Documents page of this website.<br /><br />

              You may also be able to get a copy of the Settlement Agreement and other Court documents by accessing the docket in this case, for a fee, through the
              Court’s Public Access to Court Electronic Records (PACER) system at <a href="https://ecf.cand.uscourts.gov">https://ecf.cand.uscourts.gov</a>, or by
              visiting the Office of the Clerk, United States District Court for the Northern District of California at any of the Court’s locations between
              9:00 a.m. and 4:00 p.m., Monday through Friday, excluding Court holidays.<br /><br />

              <b>PLEASE DO NOT CALL THE COURT OR THE COURT CLERK’S OFFICE ABOUT THIS SETTLEMENT. </b>
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirtyFive">
              35.	How do I get more information?
            </a>
          </div>
          <div id="collapseThirtyFive" class="collapse" data-parent="#accordion">
            <div class="card-body">
              Additional information is available on the Toll-Free Helpline or by sending an email to the Claims Administrator, including help to determine
              whether you are eligible for a payment.<br /><br />

              You may contact the Claims Administrator by calling the toll-free number, 1-877-411-4704; emailing <a href="mailto:info@GoogleAssistantPrivacyLitigation.com">info@GoogleAssistantPrivacyLitigation.com</a>,
              or writing to Google Assistant Privacy Settlement, c/o A.B. Data, Ltd., P.O. Box 170500, Milwaukee, WI 53217.<br /><br />

              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th colspan="2" style="font-weight:bold; font-size:1.2em; text-align:center;">
                        Class Counsel can be reached using the following contact information:
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="vertical-align:middle; width:50%">
                        Erin Green Comite<br />
                        Scott+Scott Attorneys at Law LLP<br />
                        156 South Main Street<br />
                        P.O. Box 192<br />
                        Colchester, CT 06415<br />
                        Telephone: (860) 537-5537<br />
                        Facsimile:  (212) 223-6334<br />
                        <a href="mailto:googleprivacysettlement@scott-scott.com">googleprivacysettlement@scott-scott.com</a>
                      </td>
                      <td style="vertical-align:middle; width:50%">
                        Christian Levis<br />
                        Lowey Dannenberg, P.C.<br />
                        44 South Broadway, Suite 1100<br />
                        White Plains, NY 10601<br />
                        Telephone: (914) 733-7205<br />
                        Facsimile:  (914) 997-0035<br />
                        <a href="mailto:googleprivacysettlement@lowey.com">googleprivacysettlement@lowey.com</a>
                      </td>
                    </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <br />
  </div>
</div>































<!--MOBILE-->
<!--<div id="mobile">
  <div class="container" style="border:1px solid #bebaba">
    <div class="row">
      <div class="col-md-12">
        <div class="orange" id="FontTwoMobile">Frequently Asked Questions</div>
        <br />
        <div style="font-size:1.4em; font-weight:bold">
          BASIC INFORMATION
        </div>
        <br />
        <div id="accordion">
          <div class="card">
            <div class="card-header">
              <a class="card-link" data-toggle="collapse" href="#collapseOne">
                1.	What is this lawsuit about?
              </a>
            </div>
            <div id="collapseOne" class="collapse" data-parent="#accordion">
              <div class="card-body">
                This class action is called <i>In re: Broiler Chicken Antitrust Litigation (End-User Consumer Action),</i> Case No. 1:16-cv-08637 (N.D. Ill.) and is pending in the United
                States District Court for the Northern District of Illinois. U.S. District Court Judge Thomas M. Durkin is in charge of this class action.<br /><br />

                End-User Consumer Plaintiffs allege that Defendants and their co-conspirators conspired to restrict the supply of, and fix, raise, and stabilize the price of
                chicken, as of January 1, 2009, in violation of federal and state consumer and antitrust laws.<br /><br />

                The Defendants and co-conspirators are chicken processors in the United States. In this notice, “Settling Defendants” refers to Fieldale, George’s, Mar-Jac, Peco,
                Pilgrim’s, and Tyson. “Non-Settling Defendants” refers to Agri Stats, Inc.; Claxton Poultry Farms, Inc.; Foster Farms, LLC, and Foster Poultry Farms; Harrison
                Poultry, Inc. and House of Raeford Farms, Inc.; JCG Foods of Alabama, LLC, JCG Foods of Georgia, LLC, Koch Foods, Inc., and Koch Meats Co., Inc.; Mountaire Farms,
                Inc., Mountaire Farms, LLC, and Mountaire Farms of Delaware, Inc.; O.K. Foods, Inc., O.K. Farms, Inc., and O.K. Industries, Inc.; Perdue Farms, Inc. and Perdue
                Foods LLC; Sanderson Farms, Inc., Sanderson Farms, Inc. (Foods Division), Sanderson Farms, Inc. (Processing Division), and Sanderson Farms, Inc.
                (Production Division); Wayne Farms, LLC; and Simmons Foods, Inc. and Simmons Prepared Foods, Inc.<br /><br />

                End-User Consumer Plaintiffs have reached Settlements with the Settling Defendants, but the End-User Consumers’ case is proceeding against the Non-Settling
                Defendants. Those other Non-Settling Defendants may be subject to separate settlements, judgments, or class certification orders. If applicable, you will receive
                a separate notice regarding the progress of the litigation and any resolution of claims against other Non-Settling Defendants.<br /><br />

                Settling Defendants have not admitted any liability and continue to deny all allegations of wrongdoing in this lawsuit and would allege numerous defenses to
                Plaintiffs’ claims if the case against it were to proceed.
              </div>
            </div>
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwo">
                2.	What is the current posture of this litigation? why did I get a notice?
              </a>
            </div>
            <div id="collapseTwo" class="collapse" data-parent="#accordion">
              <div class="card-body">
                On May 27, 2022, Judge Thomas M. Durkin issued an Order certifying a class
                of indirect purchasers generally defined as: “All persons and entities who
                indirectly purchased the following types of raw chicken, whether fresh or
                frozen: whole birds (with or without giblets), whole cut-up birds purchased
                within a package, breast cuts or tenderloin cuts, but excluding chicken
                that is marketed as halal, kosher, free range, organic, diced, minced,
                ground, seasoned, flavored, or breaded—from defendants or co-conspirators
                for personal consumption in the Repealer Jurisdictions from January 1, 2012, to July 31, 2019” (the “Certified Class”).<br />

                The notice provides Settlement Class members with an opportunity to opt out of the
                Certified Class defined above. If you exclude yourself from the Certified
                Class, you will not be able to recover any award from any future settlements
                or judgments obtained by the lawyers for the Class, if settlements or
                judgments occur. Your decision to exclude yourself (or not) from the
                Certified Class will not affect your ability to participate in the
                previous settlements reached in this litigation.<br /><br />

                You may continue to file claims for the prior settlements and doing so
                will automatically include you in any future settlement(s) or judgment(s).
                If you already filed a claim, you do not need to file another claim.

              </div>
            </div>
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseThree">
                3.	What is a class action, and who is involved?
              </a>
            </div>
            <div id="collapseThree" class="collapse" data-parent="#accordion">
              <div class="card-body">
                In a class action lawsuit, one or more people or businesses called
                “class representatives” sue on behalf of others who have similar claims,
                all of whom together are a “class.” Individual Settlement Class members
                do not have to file a lawsuit to participate in the class action
                settlement, or be bound by the judgment in the class action. One
                court resolves the issues for everyone in the class, except for
                those who exclude themselves from the class.
              </div>
            </div>
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseFour">
                4.	Why was there a Settlement?
              </a>
            </div>
            <div id="collapseFour" class="collapse" data-parent="#accordion">
              <div class="card-body">
                The Court did not decide in favor of End-User Consumer Plaintiffs or
                Settling Defendants. End-User Consumer Plaintiffs believe they may
                have won at trial and possibly obtained a greater recovery. Settling
                Defendants believe the End-User Consumer Plaintiffs may not have
                won at a trial and that End-User
                Consumer Plaintiffs would have recovered nothing against them. But
                litigation involves risks to both sides, and therefore End-User
                Consumer Plaintiffs and Settling Defendants have agreed to the
                Settlements. The Settlements required Settling Defendants
                to pay money, as well as provide specified cooperation
                (as set forth in the Settlement Agreements) in the End-User Consumer
                Plaintiffs’ continued prosecution of the litigation. End-User Consumer
                Plaintiffs and their attorneys believe the Settlements are in the best
                interests of all Settlement Class members.
              </div>
            </div>
          </div>
          <br />

          <div style="font-size:1.1em; font-weight:bold">
            WHO IS IN THE SETTLEMENT CLASS?
          </div>
          <br />

          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseFive">
                5.	Am I part of the Settlement class?.
              </a>
            </div>
            <div id="collapseFive" class="collapse" data-parent="#accordion">
              <div class="card-body">
                The Court decided that, for settlement purposes, members of the Settlement Class are defined as:<br /><br />

                All persons and entities who indirectly purchased fresh or
                frozen raw chicken (defined as whole birds (with or without giblets),
                whole cut-up birds purchased within a package, or “white meat” parts
                including breasts and wings (or cuts containing a combination of these),
                but excluding chicken that is marketed as halal, kosher, free range, or
                organic) from Defendants or alleged co-conspirators for personal
                consumption, where the person or entity purchased in California,
                District of Columbia, Florida, Hawaii, Illinois, Iowa, Kansas, Maine,
                Massachusetts, Michigan, Minnesota, Missouri, Nebraska, Nevada,
                New Hampshire, New Mexico, New York, North Carolina, Oregon, Rhode Island
                (after July 15, 2013), South Carolina, South Dakota, Tennessee, Utah, and
                Wisconsin from January 1, 2009 (except for Rhode Island, which is from
                July 15, 2013), to July 31, 2019.<br /><br/>

                The Pilgrim’s Settlement covers claims for the period of January 1, 2009
                to December 31, 2020. You are eligible to recover money if you purchased
                whole chicken, chicken breasts, or wings while a resident of one of the
                following states: California, District of Columbia, Florida, Hawaii,
                Illinois, Iowa, Kansas, Maine, Massachusetts, Michigan, Minnesota,
                Missouri, Nebraska, Nebraska, Nevada, New Hampshire, New Mexico,
                New York, North Carolina, Oregon, Rhode Island, South Carolina,
                South Dakota, Tennessee, Utah, and Wisconsin. These states allow
                for standing of End-User Consumers, the class alleged here.
                <span style="background-color: #FFFF00">Governmental and public
                entities are not included in the Settlement Class and are not eligible
                Settlement Class members.</span> <br /><br/>

                While these Settlements are only with Settling Defendants, the Settlement
                Class includes persons who purchased chicken products from <b>any</b> of the
                Non-Settling Defendants or their alleged co-conspirators. If you are a
                member of the Settlement Class and do not exclude yourself, you may be
                eligible to participate in (or exclude yourself from) any additional
                settlements which may arise with any other Non-Settling Defendants in
                the case.

              </div>
            </div>
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseSix">
                6.	Am I part of the Certified Class?
              </a>
            </div>
            <div id="collapseSix" class="collapse" data-parent="#accordion">
              <div class="card-body">
                On May 27, 2022, Judge Thomas M. Durkin issued an Order certifying a
                class of indirect purchasers generally defined as: “All persons and
                entities who indirectly purchased the following types of raw chicken,
                whether fresh or frozen: whole birds (with or without giblets),
                whole cut-up birds purchased within a package, breast cuts or
                tenderloin cuts, but excluding chicken that is marketed as halal,
                kosher, free range, organic, diced, minced, ground, seasoned,
                flavored, or breaded—from defendants or co-conspirators for personal
                consumption in the Repealer Jurisdictions from January 1, 2012,
                to July 31, 2019” (the “Certified Class”).
              </div>
            </div>
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseSeven">
                7.	What are the Repealer Jurisdictions?
              </a>
            </div>
            <div id="collapseSeven" class="collapse" data-parent="#accordion">
              <div class="card-body">
                The “Repealer Jurisdictions” are: California, District of Columbia,
                Florida, Hawaii, Illinois, Iowa, Kansas, Maine, Massachusetts, Michigan,
                Minnesota, Missouri, Nebraska, Nevada, New Hampshire, New Mexico,
                New York, North Carolina, Oregon, Rhode Island, South Carolina,
                South Dakota, Tennessee, Utah, and Wisconsin.
              </div>
            </div>
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseEight">
                8.	I'm still not sure if I'm included.
              </a>
            </div>
            <div id="collapseEight" class="collapse" data-parent="#accordion">
              <div class="card-body">
                If you are still not sure if you are included in the Settlement or Certified
                Classes, please review the detailed information contained on the Important
                Documents page of this website.-->
<!--<a href="http://www.overchargedforchicken.com" target="_blank">www.overchargedforchicken.com</a>.<br /><br />-->
<!--</div>
            </div>
          </div>

          <br />
          <div style="font-size:1.1em; font-weight:bold">
            THE BENEFITS OF THE PRIOR SETTLEMENT AGREEMENTS WITH SETTLING DEFENDANTS
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseNine">
                9.	What do the Settlements provide?
              </a>
            </div>
            <div id="collapseNine" class="collapse" data-parent="#accordion">
              <div class="card-body">
                If the Settlements are approved, Tyson will pay $99,000,000,
                Pilgrim’s will pay $75,500,000, George’s will pay $1,900,000,
                Peco will pay $1,900,000, Fieldale will pay $1,700,000, and
                Mar-Jac will pay $1,000,000. These Settlements would resolve
                all Settlement Class members’ claims against the Settling
                Defendants for the Released Claims (as defined in the Settlement
                Agreements). In addition to this monetary benefit, Settling
                Defendants have also agreed to provide specified cooperation
                (as set forth in the Settlement Agreements) in the End-User Consumer
                Plaintiffs’ continued prosecution of the litigation.
              </div>
            </div>
          </div>
          <br />

          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseTen">
                10.	What are the Settlement benefits being used for?
              </a>
            </div>
            <div id="collapseTen" class="collapse" data-parent="#accordion">
              <div class="card-body">
                No money will be distributed yet. Co-Lead Counsel will continue to pursue
                the lawsuit against the Non-Settling Defendants. A portion of the Settlement
                Proceeds has been and will be used by the Claims Administrator for notice
                and administration costs. Additionally, Co-Lead Counsel may request that
                the Court award attorneys’ fees and permit the reimbursement of certain
                litigation costs and expenses. If such request is made at this time, it
                will be filed at least fourteen days before the objection deadline and
                posted on this website at that time. Co-Lead
                Counsel will not seek more than 33.3% of the Settlement Fund or $60,273,000
                as attorneys’ fees, or $8.75 million as the total amount of costs. Co-Lead
                Counsel will request service awards of up to $2,000 on behalf of each
                Class Representative. All Settlement funds that remain after payment of
                the Court-ordered attorneys’ fees, costs, and litigation expenses will be
                distributed to Settlement Class members on a pro rata basis at the conclusion
                of the lawsuit or as ordered by the Court.
              </div>
            </div>
          </div>

          <br />
          <div style="font-size:1.1em; font-weight:bold">
            HOW YOU GET A PAYMENT
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseEleven">
                11.	How can I file a claim to get a payment from the Settlements?
              </a>
            </div>
            <div id="collapseEleven" class="collapse" data-parent="#accordion">
              <div class="card-body">
                <b>
                  *NOTE: If you have already submitted a claim, please do not submit another
                  claim.  If you have not submitted a claim in the prior settlements, you are
                  encouraged to do so now.
                </b><br /><br />

                To be eligible to receive a payment from any of the Settlements, you must complete and submit a timely Claim Form. If you submit a timely Claim Form, you will
                automatically participate in any funds received in future settlements unless you opt-out of the Certified Class. Submit your Claim Form online at
                <a href="http://www.overchargedforchicken.com" target="_blank">www.overchargedforchicken.com</a>. Or fill out the Claim Form,
                and mail it to the address below:<br /><br />

                <div class="text-center">
                  Broiler Chicken Consumer Litigation<br />
                  c/o A.B. Data, Ltd.<br />
                  P.O. Box 173045<br />
                  Milwaukee, WI 53217
                </div>
                <br /><br />

                If you do not submit a valid Claim Form by the time the claim filing period ends, you will not receive a payment from any of the Settlements, but you will be bound by the Court’s judgment
                in these actions.
              </div>
            </div>
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwelve">
                12.	When will I get payment from the Settlements?
              </a>
            </div>
            <div id="collapseTwelve" class="collapse" data-parent="#accordion">
              <div class="card-body">
                In light of the Order Certifying the Class against Non-Settling Defendants, payments from the
                Settlements are not scheduled to be distributed at this time. Updates will be provided on the Settlement
                website at <a href="http://www.overchargedforchicken.com" target="_blank">www.overchargedforchicken.com</a>
                or may be obtained by contacting the Claims Administrator.
              </div>
            </div>
          </div>

          <br />
          <div style="font-size:1.1em; font-weight:bold">
            EXCLUDING YOURSELF
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseThirteen">
                13.	How do I exclude myself from the Settlement or the Certification classes?
              </a>
            </div>
            <div id="collapseThirteen" class="collapse" data-parent="#accordion">
              <div class="card-body">
                <b>The deadline to exclude yourself from the prior settlements in this matter has passed.</b><br /><br />

                If you do not want to remain a member of the Certified Class and you
                do not want to be legally bound by the terms of any potential settlements
                or judgments, or if you wish to pursue your own separate lawsuit
                against Defendants, you must exclude yourself by submitting a written
                request to the Claims Administrator stating your intent to exclude yourself
                from the Certified Class (an “Exclusion Request”).<br /><br />

                Your Exclusion Request must include the following: (a) your name and
                address; (b) a statement that you want to be excluded from the End-User
                Consumer Certified Class in In re Broiler Chicken Antitrust Litigation
                (End-User Consumer Action); and (c) your signature. You must mail your
                Exclusion Request, postmarked by April 4, 2023, to: Broiler Chicken
                Consumer Litigation, Attn: EXCLUSIONS, c/o A.B. Data, Ltd., P.O. Box 173001, Milwaukee, WI 53217.

              </div>
            </div>
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseFourteen">
                14.	If I don't exclude myself, can I sue the Defendants for the same thing later?
              </a>
            </div>
            <div id="collapseFourteen" class="collapse" data-parent="#accordion">
              <div class="card-body">
                No. Unless you exclude yourself, you give up the right to sue the
                Non-Settling Defendants for the claims set forth in the litigation.
                If you have a pending lawsuit against one or more of the Non-Settling
                Defendants, speak to your lawyer in that lawsuit immediately to
                determine whether you must exclude yourself from this Class to
                continue your own lawsuit against Non-Settling Defendants.
              </div>
            </div>
          </div>

          <br />
          <div style="font-size:1.1em; font-weight:bold">
            OBJECTING TO THE SETTLEMENTS
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseFiftheen">
                15.	How do I tell the Court that I don't like the Settlements?
              </a>
            </div>
            <div id="collapseFiftheen" class="collapse" data-parent="#accordion">
              <div class="card-body">
                The deadline to object to the prior settlements has passed.
              </div>
            </div>
          </div>

          <br />
          <div style="font-size:1.1em; font-weight:bold">
            THE LAWYERS REPRESENTING YOU
          </div>

          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseSixteen">
                16.	Do I have a lawyer in this case?
              </a>
            </div>
            <div id="collapseSixteen" class="collapse" data-parent="#accordion">
              <div class="card-body">
                The Court has appointed Hagens Berman Sobol Shapiro LLP and Cohen
                Milstein Sellers & Toll, PLLC as Co-Lead Counsel for the Settlement
                Class and the Certified Class. If you wish to remain a member of the
                Certified Class, you do not need to hire your own lawyer
                because Co-Lead Counsel is working on your behalf. If you wish to pursue
                your own case separate from this one, or if you exclude yourself
                from the Certified Class, these lawyers will no longer
                represent you. You will need to hire your own lawyer if you wish
                to pursue your own lawsuit against Non-Settling Defendants.
              </div>
            </div>
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseSeventeen">
                17.	How will the lawyers be paid?
              </a>
            </div>
            <div id="collapseSeventeen" class="collapse" data-parent="#accordion">
              <div class="card-body">
                For the Settling Defendants,
                Co-Lead Counsel will ask the Court for attorneys’ fees at the fairness
                hearing, or at a later date, based on their services in this litigation,
                not to exceed 33.3% of the Settlement Funds (up to $60,273,000), and may
                ask to be reimbursed for up to $8.75 million in current and ongoing
                litigation expenses, and up to $2,000 in service awards for each of the
                plaintiffs serving as class representatives. Any payment to the attorneys
                will be subject to Court approval, and the Court may award less than the
                requested amount. The attorneys’ fees, costs, and expenses that the Court
                orders, plus the costs to administer the Settlements, will come out of the
                Settlement Fund. Co-Lead Counsel may seek additional attorneys’ fees,
                costs, and litigation expenses from any other settlements or recoveries
                obtained in the future. When Co-Lead Counsel’s motion for fees, costs,
                and litigation expenses is filed, a copy will be available
                on this website.
                The motion will be posted on the website at least 14 days before the deadline for objecting,
                commenting on, or excluding yourself from the Settlements.
                You will have an opportunity to comment on this request.<br /><br />

                For the Certified Class (Non-Settling Defendants) - In the event of a future
                settlement or judgment, Co-Lead Counsel will ask the Court for attorneys’ fees
                based on their services in this litigation.  Any payment to the attorneys will
                be subject to Court approval. You will not be responsible for paying Co-Lead Counsel directly.
              </div>
            </div>
          </div>
          <br />
          <div style="font-size:1.1em; font-weight:bold">
            THE COURT’S FAIRNESS HEARING
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseEighteen">
                18.	When and where will the Court decide whether to approve the Settlements?
              </a>
            </div>
            <div id="collapseEighteen" class="collapse" data-parent="#accordion">
              <div class="card-body">
                The Court held a hearing to decide whether to approve the Settlements
                (the "Fairness Hearing") on December 20, 2021, at 9:00 a.m., at the United
                States District Court for the Northern District of Illinois, Courtroom 1441,
                219 South Dearborn Street, Chicago, IL 60604. At this hearing, the Court
                considered whether the Settlements are fair, reasonable, and adequate.
                After the hearing, the Court decided to approve the Settlements.
              </div>
            </div>
          </div>
          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseNineteen">
                19.	Do I have to come to the hearing?
              </a>
            </div>
            <div id="collapseNineteen" class="collapse" data-parent="#accordion">
              <div class="card-body">
                The Fairness Hearing for the prior Settlements has already taken place.
                If additional settlements are reached you will be notified of the time,
                date and location of any Fairness Hearing.<br /><br />

                You are not required to attend the Hearing. Co-Lead Counsel will answer
                any questions the Court may have. However, you are welcome to come at your
                own expense. If you send an objection to any future Settlement, should one
                be reached, you do not have to come to court to talk about it. As long as
                you followed the prescribed method of submission, the Court will consider it. You may also pay your own
                lawyer to attend, but it’s not necessary.
              </div>
            </div>
          </div>

          <br />
          <div style="font-size:1.1em; font-weight:bold">
            GETTING MORE INFORMATION
          </div>

          <br />
          <div class="card">
            <div class="card-header">
              <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwenty">
                20.	How do I get more information about the Settlements and/or Class Certification?
              </a>
            </div>
            <div id="collapseTwenty" class="collapse" data-parent="#accordion">
              <div class="card-body">
                More details are available in the Notices, Orders, and Settlement Agreements
                available on this website.
                If you have a specific question that is not addressed in these documents, you may
                contact the Claims Administrator using the information on the "Contact" page of this website.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
  </div>
  <br />
  <app-footer></app-footer>
</div>-->
